import axios from 'axios';





// Axios 공통 설정 객체 생성
const client = axios.create({

    // Spring Boot 서버 주소
   // baseURL: 'http://localhost:8080/api'
   // baseURL: '/api'
    baseURL: '/api'
});

// 전체 게시글 조회
export const getAllPosts = async () => {

    const response =
        await client.get('/posts');

    return response.data;
};



// 모든 요청 전에 자동 실행
client.interceptors.request.use((config) => {

    // 저장된 JWT 가져오기
    const token =
        localStorage.getItem('token');





    // 토큰 존재 시
    if(token) {

        // Authorization 헤더 자동 추가
        config.headers.Authorization =

            `Bearer ${token}`;
    }





    return config;
});





export default client;